export enum IconName {
  BUS = 'bus',
  ONEWAY = 'oneway',
  SUSTAINABILITY_BALL = 'sustainability-block',
  SUSTAINABILITY = 'sustainability',
  INFO = 'info-block',
  INFO_OUTLINE = 'info-outline',
  CHECKMARK = 'checkmark-block',
  ALERT_TRIANGLE = 'alert-block-triangle',
  REMOVE = 'close-delete-block',
  SAF = 'saf',
}
